export const Text = {
  variants: {
    default: {
      color: 'inherit'
    },
    muted: {
      color: 'var(--muted)'
    }
  },
  defaultProps: {
    variant: 'default',
    size: 'md'
  }
}
